import React from 'react';
import { arrayOf, bool, func, oneOf, shape, string } from 'prop-types';
import { EvaluateFlag } from 'common/FeatureFlags/Flag';
import Terminals from 'feature/loading-management/customer-authorizations/edit/Terminals';
import TerminalsAccordion from 'feature/loading-management/customer-authorizations/components/TerminalsAccordion';
import TerminalsTabContent from './TerminalsTabContent';

const TerminalsTab = ({ customerAuth, isEditMode, mode, setCustomerAuth }) => {
  const terminalsTabFlag = EvaluateFlag(
    process.env.REACT_APP_LD_CUSTOMER_AUTHORIZATION_TERMINALS_TAB
  );

  if (terminalsTabFlag) {
    return (
      <TerminalsTabContent
        customerAuth={customerAuth}
        mode={mode}
        setCustomerAuth={setCustomerAuth}
      />
    );
  }

  return (
    <div>
      {isEditMode ? (
        <Terminals info={customerAuth} setInfo={setCustomerAuth} />
      ) : (
        <TerminalsAccordion
          controlType={customerAuth.controlType}
          defaultExpanded
          terminals={customerAuth.terminals || []}
        />
      )}
    </div>
  );
};

TerminalsTab.propTypes = {
  customerAuth: shape({
    controlType: string,
    terminals: arrayOf(shape({})),
  }).isRequired,
  isEditMode: bool.isRequired,
  mode: oneOf(['edit', 'view']).isRequired,
  setCustomerAuth: func.isRequired,
};

export default TerminalsTab;
